import React, {Component} from 'react';
import {connect} from 'react-redux';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import {CircularProgress, Snackbar, Dialog, Portal} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import ColAtm from '../../../../atomic/Col/Col';
import LabelAtm from '../../../../atomic/Label/Label';
import {getProfile} from '../../../../../redux/actions/User/Profile/profileAction';
import {getWebTemplateList, updateWebTemplate, clearWebTemplate} from '../../../../../redux/actions/Web/Template/webTemplateActions';

const ALLOWED_EMAILS = [
    'cemile@extranetwork.com',
    'yoy@extranetwork.com',
    'onur@extranetwork.com',
    'cem@extranetwork.com',
    'cem@enwtest.com',
    'burhan@extranetwork.com',
    'bulut@extranetwork.com',
    'partnerships@extranetwork.com',
    'zehra@extranetwork.com'
];

// Tema id'lerine göre görünen isimler
const THEME_NAMES = {
    1: 'Boutique',
    2: 'Stork',
    3: 'Oscar',
    4: 'Qlusive',
    5: 'Valencia',
    6: 'Solene',
    8: 'Folio',
};

class WebTemplateSelect extends Component {
    constructor(props) {
        super(props);

        const current = props.currentTemplate;

        this.state = {
            selectedTemplateId: current && current.id ? current.id : 1,
            currentTemplateId: current && current.id ? current.id : 1,
            showSnackbar: false,
            snackbarType: 'success',
            snackbarMessage: '',
            previewOpen: false,
            previewSrc: '',
            previewName: '',
        };
    }

    componentDidMount() {
        if (!this.props.userEmail && typeof this.props.getProfile === 'function') {
            this.props.getProfile();
        }
        if (typeof this.props.getWebTemplateList === 'function') {
            this.props.getWebTemplateList();
        }
    }

    componentDidUpdate(prevProps) {
        // Kayıt tamamlandığında geri bildirim göster
        if (prevProps.updateFetching && !this.props.updateFetching) {
            const updateData = this.props.updateData;
            if (updateData && updateData.status === 200 && !updateData.error) {
                const savedId = (updateData.data && updateData.data.template_id) || this.state.selectedTemplateId;
                this.setState({
                    showSnackbar: true,
                    snackbarType: 'success',
                    snackbarMessage: 'Tema başarıyla güncellendi.',
                    selectedTemplateId: savedId,
                    currentTemplateId: savedId,
                });
            } else if (this.props.updateError || (updateData && updateData.error)) {
                this.setState({
                    showSnackbar: true,
                    snackbarType: 'error',
                    snackbarMessage: (updateData && updateData.message) || 'Tema güncellenirken bir hata oluştu. Lütfen tekrar deneyin.',
                });
            }
        }
    }

    handleSelect = (templateId) => {
        if (this.props.updateFetching) return;
        if (templateId === this.state.selectedTemplateId) return;
        this.setState({selectedTemplateId: templateId});
        // Parent'a tema değiştiğini bildir (ana Kaydet butonunu aktive etmek için)
        if (typeof this.props.onTemplateChange === 'function') {
            this.props.onTemplateChange(templateId);
        }
    };

    // Dışarıdan (ana Kaydet butonu) çağrılır
    saveTemplate = () => {
        const {userEmail, updateFetching} = this.props;
        if (updateFetching) return;
        if (!userEmail || !ALLOWED_EMAILS.includes(userEmail.toLowerCase())) return;
        const {selectedTemplateId, currentTemplateId} = this.state;
        if (selectedTemplateId === currentTemplateId) return; // tema değişmediyse servise gitme
        this.props.updateWebTemplate({template_id: selectedTemplateId});
    };

    handleCloseSnackbar = () => {
        this.setState({showSnackbar: false});
    };

    handleOpenPreview = (e, src, name) => {
        e.stopPropagation();
        this.setState({previewOpen: true, previewSrc: src, previewName: name});
    };

    handleClosePreview = () => {
        this.setState({previewOpen: false});
    };

    getTemplates = () => {
        const listData = this.props.listData;
        if (listData && listData.status === 200 && !listData.error && Array.isArray(listData.data)) {
            return listData.data.filter(template => template.status === 1);
        }
        return [];
    };

    render() {
        const {userEmail, fetching, updateFetching} = this.props;
        const {selectedTemplateId, currentTemplateId, showSnackbar, snackbarType, snackbarMessage,
            previewOpen, previewSrc, previewName} = this.state;

        // Sadece izinli kullanıcılara göster
        if (!userEmail || !ALLOWED_EMAILS.includes(userEmail.toLowerCase())) {
            return null;
        }

        const templates = this.getTemplates();

        return (
            <ExpansionPanel className="accordion-room-table">
                <ExpansionPanelSummary
                    expandIcon={<i className="fas fa-caret-down" />}
                    aria-label="Expand"
                    aria-controls="web-template-content"
                    id="webTemplate">
                    <ColAtm>
                        <ColAtm md={10} xl={11}>
                            <i className="fas fa-palette room-rate-bed" />
                            <LabelAtm labelClass="room-rate-list-title" text="Web Tema Seçimi" />
                        </ColAtm>
                    </ColAtm>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className="offer-photos-detail MuiGrid-root MuiGrid-container MuiGrid-item">
                    <ColAtm xs={12} className="d-block mb-20">
                        <LabelAtm variant="h2" text="Tema Seçin" labelClass="mb-20" />
                        <LabelAtm variant="p" labelClass="f-w-500"
                                  text="Web siteniz için bir tasarım teması seçin. Seçtiğiniz tema yayınlanan sitenize uygulanır."
                        />
                    </ColAtm>

                    {fetching ? (
                        <ColAtm xs={12} className="text-center" style={{padding: '40px 0'}}>
                            <CircularProgress size={32} />
                        </ColAtm>
                    ) : templates.length === 0 ? (
                        <ColAtm xs={12}>
                            <Alert severity="info">Gösterilecek tema bulunamadı.</Alert>
                        </ColAtm>
                    ) : (
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 20,
                            width: '100%',
                            marginBottom: "1rem",
                        }}>
                            {templates.map((template) => {
                                const isSelected = selectedTemplateId === template.id;
                                const isCurrent = currentTemplateId === template.id;
                                const imgSrc = `${process.env.PUBLIC_URL}/assets/img/themes/theme_${template.folder_name}.png`;
                                const displayName = THEME_NAMES[template.id] || template.name;
                                return (
                                    <div
                                        key={template.id}
                                        onClick={() => this.handleSelect(template.id)}
                                        style={{
                                            position: 'relative',
                                            width: 175,
                                            height: 175,
                                            border: isSelected ? '2px solid #d71f26' : '2px solid #e6e9ef',
                                            borderRadius: 12,
                                            overflow: 'hidden',
                                            cursor: updateFetching ? 'default' : 'pointer',
                                            background: '#f3f4f6',
                                            boxShadow: isSelected ? '0 6px 20px rgba(215, 31, 38, 0.18)' : '0 2px 8px rgba(31, 41, 55, 0.06)',
                                            transition: 'box-shadow .2s ease, border-color .2s ease, transform .2s ease',
                                            transform: isSelected ? 'translateY(-2px)' : 'none',
                                        }}
                                    >
                                        {/* Seçili rozeti */}
                                        {isSelected && (
                                            <div style={{
                                                position: 'absolute',
                                                top: 8,
                                                right: 8,
                                                zIndex: 2,
                                                background: '#d71f26',
                                                color: '#fff',
                                                borderRadius: 20,
                                                padding: '3px 9px',
                                                fontSize: 11,
                                                fontWeight: 600,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 4,
                                                boxShadow: '0 2px 6px rgba(0,0,0,.15)',
                                            }}>
                                                <i className="fas fa-check-circle" /> Seçili
                                            </div>
                                        )}

                                        {/* Mevcut tema rozeti */}
                                        {isCurrent && !isSelected && (
                                            <div style={{
                                                position: 'absolute',
                                                top: 8,
                                                right: 8,
                                                zIndex: 2,
                                                background: '#10b981',
                                                color: '#fff',
                                                borderRadius: 20,
                                                padding: '3px 9px',
                                                fontSize: 11,
                                                fontWeight: 600,
                                                boxShadow: '0 2px 6px rgba(0,0,0,.15)',
                                            }}>
                                                Mevcut Tema
                                            </div>
                                        )}

                                        {/* Büyüteç - büyük önizleme */}
                                        <button
                                            type="button"
                                            title="Büyük göster"
                                            onClick={(e) => this.handleOpenPreview(e, imgSrc, displayName)}
                                            style={{
                                                position: 'absolute',
                                                top: 8,
                                                left: 8,
                                                zIndex: 2,
                                                width: 30,
                                                height: 30,
                                                borderRadius: '50%',
                                                border: 'none',
                                                background: 'rgba(31, 41, 55, 0.55)',
                                                color: '#fff',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: 13,
                                                boxShadow: '0 2px 6px rgba(0,0,0,.2)',
                                                transition: 'background .2s ease',
                                            }}
                                            onMouseEnter={(e) => { e.currentTarget.style.background = '#d71f26'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(31, 41, 55, 0.55)'; }}
                                        >
                                            <i className="fas fa-search-plus" />
                                        </button>

                                        <img
                                            src={imgSrc}
                                            alt={displayName}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                objectPosition: 'top center',
                                                display: 'block',
                                            }}
                                            onError={(e) => {
                                                // React onError'ı addEventListener ile bağlar; e.target.onerror = null
                                                // React'in dinleyicisini kaldırmaz. Yedek görsel de hata verirse
                                                // sonsuz döngü oluşmasın diye tek denemeyle sınırlıyoruz.
                                                if (e.target.dataset.fallbackApplied) {
                                                    return;
                                                }
                                                e.target.dataset.fallbackApplied = '1';
                                                e.target.src = `${process.env.PUBLIC_URL}/assets/img/themes/theme_default.png`;
                                            }}
                                        />

                                        {/* Alt overlay: tema adı + seçim göstergesi */}
                                        <div style={{
                                            position: 'absolute',
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            zIndex: 2,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: 6,
                                            padding: '14px 10px 8px',
                                            background: 'linear-gradient(to top, rgba(0,0,0,.7), rgba(0,0,0,0))',
                                        }}>
                                            <span style={{
                                                fontWeight: 600,
                                                color: '#fff',
                                                fontSize: 15,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            }}>
                                                {displayName}
                                            </span>
                                            <span style={{
                                                flex: '0 0 auto',
                                                width: 18,
                                                height: 18,
                                                borderRadius: '50%',
                                                background: '#fff',
                                                border: isSelected ? '5px solid #d71f26' : '2px solid #cbd2dc',
                                                boxSizing: 'border-box',
                                                transition: 'border .2s ease',
                                            }} />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* <Portal>
                        <Snackbar
                            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                            open={showSnackbar}
                            autoHideDuration={3000}
                            onClose={this.handleCloseSnackbar}
                        >
                            <Alert onClose={this.handleCloseSnackbar} severity={snackbarType}>
                                {snackbarMessage}
                            </Alert>
                        </Snackbar>
                    </Portal> */}

                    {/* Tema büyük önizleme */}
                    <Dialog
                        open={previewOpen}
                        onClose={this.handleClosePreview}
                        maxWidth="lg"
                        aria-labelledby="web-template-preview"
                    >
                        <div style={{position: 'relative', background: '#000', lineHeight: 0}}>
                            <button
                                type="button"
                                title="Kapat"
                                onClick={this.handleClosePreview}
                                style={{
                                    position: 'absolute',
                                    top: 10,
                                    right: 10,
                                    zIndex: 2,
                                    width: 36,
                                    height: 36,
                                    borderRadius: '50%',
                                    border: 'none',
                                    background: 'rgba(255, 255, 255, 0.85)',
                                    color: '#1f2937',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: 16,
                                    boxShadow: '0 2px 8px rgba(0,0,0,.3)',
                                }}
                            >
                                <i style={{position: "relative", top: "1px"}} className="fas fa-times" />
                            </button>
                            {previewName && (
                                <div style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    padding: '12px 16px',
                                    background: 'linear-gradient(to top, rgba(0,0,0,.6), rgba(0,0,0,0))',
                                    color: '#fff',
                                    fontWeight: 600,
                                    fontSize: 28,
                                    lineHeight: 1.4,
                                }}>
                                    {previewName}
                                </div>
                            )}
                            <img
                                src={previewSrc}
                                alt={previewName}
                                style={{
                                    display: 'block',
                                    maxWidth: '90vw',
                                    maxHeight: '85vh',
                                    width: '100%',
                                    height: 'auto',
                                }}
                            />
                        </div>
                    </Dialog>
                </ExpansionPanelDetails>
                <style>{`
                    .MuiCircularProgress-indeterminate {
                        color: #fff;
                        position: relative !important;
                    }
                `}</style>
            </ExpansionPanel>
        );
    }
}

const mapStateToProps = (state) => ({
    userEmail: state.profileReducer && state.profileReducer.profileData
        && state.profileReducer.profileData.profile
        && state.profileReducer.profileData.profile.email,
    fetching: state.webTemplateReducer && state.webTemplateReducer.fetching,
    listData: state.webTemplateReducer && state.webTemplateReducer.listData,
    updateFetching: state.webTemplateReducer && state.webTemplateReducer.updateFetching,
    updateData: state.webTemplateReducer && state.webTemplateReducer.updateData,
    updateError: state.webTemplateReducer && state.webTemplateReducer.updateError,
});

const mapDispatchToProps = {
    getProfile,
    getWebTemplateList,
    updateWebTemplate,
    clearWebTemplate,
};

// forwardRef: parent (WebEditAccordions) ana Kaydet'te saveTemplate() metodunu çağırılır
export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(WebTemplateSelect);
